var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ 'btn': true,
                 'btn-primary': _vm.classDefault === 'btn-primary',
                 'btn-secondary': _vm.classDefault === 'btn-secondary',
                 'btn-success': _vm.classDefault === 'btn-success',
                 'btn-warning': _vm.classDefault === 'btn-warning',
                 'btn-danger': _vm.classDefault === 'btn-danger',
                 'vue-btn-loader-error': !_vm.isSuccess && !_vm.emptyStatus, 
                 'vue-btn-loader-success': _vm.isSuccess, 
                 'is-loading': _vm.isLoading}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{class:{ 'spinner': _vm.loading, 'check': !_vm.emptyStatus && _vm.isSuccess && !_vm.loading, 'cross': !_vm.emptyStatus && !_vm.isSuccess && !_vm.loading }})]),_vm._v(" "),(_vm.showSlot)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6173b2c6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueButtonSpinner.vue
// module id = 1428
// module chunks = 2